module.exports = __webpack_public_path__ + "static/bigpanel-bg-sp-06376be627a8ae8c9c344ea591258f74.jpg";